// src/components/SiteSelector/SiteSelector.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelectedSite } from '../../contexts/SelectedSiteContext';

async function defaultLoadSites({ backendUrl, user }) {
  const res = await axios.get(`${backendUrl}/sites`, {
    headers: { Authorization: `Bearer ${user.token}` },
  });
  return res.data ?? [];
}

export default function SiteSelector({
  backendUrl,
  user,
  loadSites = defaultLoadSites,  // injection for Storybook/tests
  disabled = false,
  onChange,
}) {
  const { selectedSite, setSelectedSite } = useSelectedSite();

  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!backendUrl || typeof user?.token !== 'string' || !user.token.trim()) {
      setSites([]);
      setErr(null);
      setLoading(false);
      return () => { cancelled = true; };
    }
    (async () => {
      setLoading(true);
      setErr(null);
      setSites([]); // clear to avoid stale options
      try {
        const data = await loadSites({ backendUrl, user });
        if (!cancelled) setSites(data);
      } catch (e) {
        if (!cancelled) setErr(e?.message || 'Failed to load sites');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [backendUrl, user, loadSites]);

  return (
    <div style={{ display: 'grid', gap: 6 }}>
      <label htmlFor="plot-site" style={{ fontSize: 14 }}>Site</label>
      <select
        id="plot-site"
        value={selectedSite ?? ''}
        onChange={e => (onChange ?? setSelectedSite)(Number(e.target.value))}
        disabled={disabled || loading || !!err}
        style={{ padding: '6px 8px' }}
      >
        <option value="" disabled>Choose a site…</option>
        {sites.map(s => (
          <option key={s.id} value={s.id}>{s.name} (#{s.id})</option>
        ))}
      </select>
      {loading && <div style={{ fontSize: 12, opacity: 0.7 }}>Loading sites…</div>}
      {err && <div style={{ color: 'tomato', fontSize: 12 }}>{String(err)}</div>}
    </div>
  );
}
